import { ReactNode } from 'react'

type Props = {
  children: ReactNode | ReactNode[]
  flexGrow?: number
  flexBasis?: string
  justifySelf?: 'auto' | 'stretch' | 'center' | 'start' | 'end'
  textAlign?: 'center' | 'left' | 'right'
  width?: string
  minWidth?: string
  maxWidth?: string
  minHeight?: string
  padding?: string
}

const AppFlexItem = ({
  children,
  flexGrow = 0,
  flexBasis = '',
  justifySelf = 'auto',
  textAlign = 'left',
  width = 'initial',
  minWidth = 'initial',
  maxWidth = 'initial',
  minHeight = 'initial',
  padding = 'initial',
}: Props) => {
  return (
    <div
      style={{
        flexGrow,
        flexBasis,
        justifySelf,
        textAlign,
        width,
        minWidth,
        maxWidth,
        minHeight,
        padding,
      }}
    >
      {children}
    </div>
  )
}

export default AppFlexItem
